import React from "react";
import { SideMenu, BackHeader,Model } from "./../../components";
import EventVenueIcon from "./../../../assets/svg/eventVenueIcon.svg";
import { MdOutlineLocationOn } from "react-icons/md";
import CoverImage from "./../../../assets/images/profileHeader.png";
import { useNavigate, useLocation } from "react-router-dom";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { Button } from "@mui/material";
import { IoMdCall } from "react-icons/io";
let OrganizeEventView = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [invite, setInvite] = React.useState(false);
  return (
    <SideMenu>
      <div className="page-details-container">
        <BackHeader backHanler={() => navigate(-1)} />
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid item xl={10} lg={10} md={10} sm={12} xs={12}>
              <p className="data-view-heading">Lorem ipsum dolor sit amet</p>
              <div className="data-view-header-location-main">
                <MdOutlineLocationOn color="#663399" size={25} />
                <p className="data-view-header-location">burnside</p>
              </div>
            </Grid>
            <Grid item xl={2} lg={2} md={2} sm={12} xs={12}>
              <Button className="header-button" variant="text" onClick={()=> setInvite(true)}>
                <p className="page-header-button-text">Invite</p>
              </Button>
            </Grid>
          </Grid>
        </Box>

        <img src={CoverImage} className="data-view-header-cover-image" />
        <div className="data-view-cover-footer-container">
          <div className="data-view-cover-footer">
            <p className="data-view-cover-footer-date">14 march 2022,</p>
          </div>
          {location.state.type === "Online" ? (
            <div className="organize-event-data-view-location-main">
              <MdOutlineLocationOn color="#663399" size={25} />
              <p className="organize-event-data-view-location">Online, Free</p>
            </div>
          ) : (
            <div className="organize-event-data-view-location-main">
              <p className="organize-event-data-view-location">$1000</p>
            </div>
          )}
        </div>
        <div className="organize-event-view-user-data-container">
          <div>
            <h1 className="organize-event-view-user-name">
              Tutor Name: Willow Anderson{" "}
            </h1>
            <h1 className="organize-event-view-user-email">
              willowAnderson@gmail.com{" "}
            </h1>
          </div>
          <div className="organize-event-view-user-phone-number-main">
            <IoMdCall />
            <p>+971 1234567890</p>
          </div>
        </div>
        {location.state.type === "Online" ? (
          <h1 className="organize-event-view-highlights-heading">Highlights</h1>
        ) : (
          <h1 className="organize-event-view-highlights-heading">
            Discription
          </h1>
        )}
        <p className="data-view-description">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. In in lorem
          congue, euismod urna vitae, porttitor mi. Aliquam consectetur eu
          turpis ac congue. <br /> <br />
          Curabitur viverra nunc cursus est efficitur, sit amet ornare felis
          accumsan. Ut eget elementum sem. Sed et nibh pharetra. Lorem ipsum
          dolor sit amet, consectetur adipiscing elit. In in lorem congue,
          euismod urna vitae, porttitor mi. Aliquam consectetur eu turpis ac
          congue. <br /> <br />
          Curabitur viverra nunc cursus est efficitur, sit amet ornare felis
          accumsan. Ut eget elementum sem. Sed et nibh pharetra.
        </p>
        {location.state.type !== "Online" && (
          <div>
            <div className="data-view-card-main">
              <p className="data-view-card-title">Event Venue</p>
            </div>
            <div className="data-view-card-list-main">
              <div>
                <p className="data-view-card-list-heading">Burnside</p>
                <p className="data-view-card-list-description">
                  Tavern, Plot 108, Rambaug Colony, MIT Road, Kothrud, burnside
                </p>
              </div>
              <div className="data-view-card-list-icon">
                <img src={EventVenueIcon} />
              </div>
            </div>
          </div>
        )}
      </div>

      <Model
        modelTitle="Invite"
        width="md"
        onClose={() => setInvite(false)}
        open={invite}
        buttonTitle="Invite Now"
        buttonHandler={() => setInvite(false)}
      >
        <div className="form-container">
          <Box sx={{ flexGrow: 1 }}>
            <Grid container spacing={2}>
              <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
              <div>
                <p className="input-heading">Class</p>
                <select className="input">
                  <option value="">Select class</option>
                </select>
              </div>
              </Grid>
              <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
              <div>
                <p className="input-heading">Division</p>
                <select className="input">
                  <option value="">Select Division</option>
                </select>
              </div>
              </Grid>
            </Grid>
          </Box>
        </div>
      </Model>
    </SideMenu>
  );
};
export default OrganizeEventView;
